import React, { useEffect, useState } from 'react';
import { Box, Card, Divider, Typography, Button } from '@mui/material';
import { fCurrency } from '../../../utils/formatNumber';
import { firestore } from '../../../contexts/FirebaseContext';
import useAuth from '../../../hooks/useAuth';
import DialogHistory from './DialogHistory';
import { startDate } from '../../../constants/estartDate';

function History({ user, neededUserId }) {
  const [transactions, setTransactions] = useState([]);
  const [openHistory, setOpenHistory] = useState(false);
  // const { user } = useAuth();
  // console.log(user);

  // console.log(transactions);

  const formatCat = (cat) => {
    switch (cat) {
      case 'SERVICIO':
        return 'Saldo servicio';

      case 'PAQUETERIA':
        return 'Saldo paquetería';

      case 'RECARGA':
        return 'Saldo recarga';

      default:
        return 'Algun movimiento';
    }
  };

  useEffect(() => {
    async function getransactionsUser() {
      await firestore
        .collection('transactionUsers')
        .where('user_id', '==', neededUserId)
        // .where('updated_at', '>', startDate)
        .orderBy('updated_at', 'desc')
        .onSnapshot((queryS) => {
          const dat = [];
          queryS.forEach((doc) => {
            dat.push({
              id: doc.id,
              ...doc.data()
            });
          });
          // console.log(dat);
          setTransactions(dat);
        });
    }
    getransactionsUser();
  }, [neededUserId]);
  return (
    <Card sx={{ padding: '20px' }}>
      <Typography variant="h5">Historial de transacciones</Typography>
      <Divider />
      <Box sx={{ marginTop: '15px' }}>
        {transactions.slice(0, 6).map((tran) => {
          const { id, amount, increase, categoryService, reason } = tran;
          // console.log(tran);
          return (
            <Card
              key={tran.id}
              sx={{
                padding: '10px',
                display: 'flex',
                gap: '15px',
                justifyContent: 'space-between',
                marginTop: '5px',
                borderRadius: '5px'
              }}
            >
              {/* <Typography variant="body2" fontWeight="600">
                {formatCat(categoryService)}
              </Typography> */}
              <Typography variant="body2" fontWeight="600">
                {reason || '-'}
              </Typography>
              <Typography variant="body2" color={increase ? 'secondary' : 'error'}>
                {increase ? '+' : '-'} {fCurrency(amount)}
              </Typography>
            </Card>
          );
        })}
      </Box>
      <Box>
        <Button onClick={() => setOpenHistory(true)}>Ver historial completo</Button>
        <DialogHistory open={openHistory} onClose={setOpenHistory} transactions={transactions} />
      </Box>
    </Card>
  );
}

export default History;
